import React, { useState } from "react";
import { Headphones } from "lucide-react";
import { MoodJourneyChoices } from "../journey/MoodJourneyChoices";
import { TOK, SERIF, SANS, PrimaryBtn, QuietLink, Title } from "./shared";

const DURATIONS = [5, 10, 15, 20, 30];

const Durations = ({ minutes, setMinutes }) => (
  <div className="flex flex-wrap justify-center gap-2">
    {DURATIONS.map((d) => (
      <button key={d} type="button" onClick={() => setMinutes(d)} data-testid={`simple-duration-${d}`}
        className="rounded-full px-4 py-2 text-xs transition-colors duration-200"
        style={{ fontFamily: SANS, border: `1px solid ${d === minutes ? TOK.gold : TOK.goldMist}`, color: d === minutes ? TOK.ink : TOK.creamDim, background: d === minutes ? TOK.gold : "transparent" }}>
        {d} min
      </button>
    ))}
  </div>
);

// Step 4 — Create. Soulumo has already chosen the journey, music, tones and length; control lives under More options.
export const CreateStep = ({ plan, setPlan, intent, minutes, setMinutes, onCreate, onMoreOptions, error }) => {
  const [open, setOpen] = useState(false);
  const [ids, setIds] = useState([]);
  const [feel, setFeel] = useState(null);
  const words = feel || plan.feel_words || [];
  return (
    <div className="space-y-7" data-testid="simple-create-step">
      <div>
        <div className="text-[0.62rem] uppercase tracking-[0.3em]" style={{ color: TOK.goldSoft, fontFamily: SANS }}>Recommended for you</div>
        <div className="mt-2"><Title>{plan.journey_name}</Title></div>
        <p className="mt-3 text-xl italic" style={{ color: TOK.creamDim, fontFamily: SERIF }} data-testid="simple-create-feel">
          {[...words.slice(0, 3), `${minutes} minutes`].join(" · ")}
        </p>
      </div>
      {error && <p className="text-sm" style={{ color: "#e9a39c", fontFamily: SANS }} data-testid="simple-create-error">{error}</p>}
      <PrimaryBtn testId="simple-create-btn" onClick={onCreate}><Headphones size={16} /> Create my installation</PrimaryBtn>
      {open ? (
        <div className="space-y-5" data-testid="simple-create-options">
          <div className="text-[0.62rem] uppercase tracking-[0.3em]" style={{ color: TOK.goldSoft, fontFamily: SANS }}>Journey</div>
          <MoodJourneyChoices theme={plan.theme_id} concern={intent} selectedIds={ids} autoSelect={false}
            onSelect={(next, _mood, c) => { setIds(next); setFeel(c?.feelings || null); setPlan((p) => ({ ...p, music_ids: next })); }} />
          <Durations minutes={minutes} setMinutes={setMinutes} />
          <QuietLink testId="simple-create-more-options" onClick={() => onMoreOptions(intent)}>Full control ›</QuietLink>
        </div>
      ) : (
        <QuietLink testId="simple-create-change" onClick={() => setOpen(true)}>More options</QuietLink>
      )}
    </div>
  );
};
